import { render, staticRenderFns } from "./OwnersCreate.vue?vue&type=template&id=69e42514&"
import script from "./OwnersCreate.vue?vue&type=script&lang=js&"
export * from "./OwnersCreate.vue?vue&type=script&lang=js&"
import style0 from "./OwnersCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports